module.exports = __webpack_public_path__ + "static/media/m25_thumb_even.c5316d31.jpg";